import React from "react";
import { isCurrentWeek } from "../../../../../utils/annual-planner-helpers";
import { PhaseCheckbox } from "./";

// current-week marks the grid's vertical divider (Fase 4) - same .current-week
// class + shared CSS rule as StatsCard.js's .stats-column, WeekOfRow.js's
// .week-of-date-slot and PhasesDescriptionBubbles.js's .description-bubble-slot,
// each a full-width per-week flex slot the class lands on directly.
// MilestoneCounter.js is the one exception: it's row-per-milestone with weeks
// nested inside, so there's no single per-week box across all its rows for
// this class to mark - it draws one absolutely-positioned overlay instead
// (.milestones-current-week-marker), not this class.
export const PhaseColumn = ({
  exactWeek,
  phases,
  weekFirstDay,
  handlePhaseSelection,
  phasesAttachments,
}) => {
  return (
    <div
      key={exactWeek}
      className={`phase-column${isCurrentWeek(weekFirstDay) ? " current-week" : ""}`}
    >
      {phases?.map((phase, index) => (
        //   Checkbox for each training phase
        <PhaseCheckbox
          key={phase.phaseName}
          classNames="phase-checkbox"
          name={exactWeek}
          phase={phase}
          phasesAttachments={phasesAttachments}
          handlePhaseSelection={handlePhaseSelection}
          index={index}
          weekFirstDay={weekFirstDay}
        />
      ))}
    </div>
  );
};
